import request from '@/lib/api'

const _BASE = "/api";
//=============================服务使用者管理=========================

// 服务使用者管理==服务使用者列表（搜索以及分页）
export function getServeUserlist(params) {
  return request({
    url: `${_BASE}/tPmcUser/users`,
    method: 'get',
    params
  })
}
// 服务使用者管理==服务使用者列表==服务使用者详情
export function getServeUserDetail(id) {
  return request({
    url: `${_BASE}/tPmcUser/user/${id}`,
    method: 'get',
  })
}
// 服务使用者管理==服务使用者列表==已发布服务
export function getServePubilshlist(params) {
  return request({
    url: `${_BASE}/tPmcUser/user/application`,
    method: 'get',
    params
  })
}
// 服务使用者管理==服务使用者列表==已发布服务详情（基础信息）
export function getServePubilshBase(id) {
  return request({
    url: `${_BASE}/tPmcUser/application/${id}`,
    method: 'get',
  })
}
// 服务使用者管理==服务使用者列表==已发布服务详情（服务列表）
export function getServePubilshServeList(id) {
  return request({
    url: `${_BASE}/tPmcUser/application/service/${id}`,
    method: 'get',
  })
}
// 服务使用者管理==服务使用者列表==已发布服务详情（视频资源）
export function getServePubilshResourceList(id, params) {
  return request({
    url: `${_BASE}/tPmcUser/application/resource/${id}`,
    method: 'get',
    params
  })
}
//=============================服务使用者审核=========================

// 服务使用者管理==服务使用者审核列表（搜索以及分页）
export function getServeUserChecklist(params) {
  return request({
    url: `${_BASE}/tPmcUser/audit`,
    method: 'get',
    params
  })
}
// 服务提供者管理==服务提供者审核列表==服务提供者详情
export function getServeUserCheckDetail(id) {
  return request({
    url: `${_BASE}/tPmcUser/audit/${id}`,
    method: 'get',
  })
}
// 服务提供者管理==服务提供者审核列表==审核通过
export function serveUserCheckPass(id) {
  return request({
    url: `${_BASE}/tPmcUser/pass/${id}`,
    method: 'put',
  })
}

// 服务提供者管理==服务提供者审核列表==驳回
export function serveUserCheckReturn(id, params) {
  return request({
    url: `${_BASE}/tPmcUser/reject/${id}`,
    method: 'put',
    params
  })
}


